(function () {
  function initB1G2() {
    var root = document.querySelector('[data-ns-b1g2]');
    if (!root) return;

    if (root.__nsB1G2Initialized === true) return;

    root.__nsB1G2Initialized = true;
    root.dataset.initialized = 'true';
    document.body.classList.add('ns-b1g2-enabled');

    var modal = root.querySelector('[data-ns-b1g2-modal]');
    var dialog = root.querySelector('.ns-b1g2-dialog');
    var cards = Array.from(root.querySelectorAll('[data-ns-b1g2-gift]:not(:disabled)'));
    var closeButtons = Array.from(root.querySelectorAll('[data-ns-b1g2-close]'));
    var confirmButton = root.querySelector('[data-ns-b1g2-confirm]');
    var count = root.querySelector('[data-ns-b1g2-count]');
    var status = root.querySelector('[data-ns-b1g2-status]');
    var errorBox = root.querySelector('[data-ns-b1g2-error]');
    var skipButton = root.querySelector('[data-ns-b1g2-skip]');
    var required = Number(root.dataset.required || 2);
    var discountCode = root.dataset.discountCode || 'B1G2';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var dismissalStorageKey = 'ns_b1g2_popup_dismissed_at';
    var dismissalCooldownMs = 60 * 1000;
    var selected = new Set();
    var pendingForm = null;
    var busy = false;
    var lastFocused = null;
    var offerAlreadyClaimed = false;

    function routesRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function requestJson(url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Le panier n’a pas pu être mis à jour.');
          }
          return payload;
        });
      });
    }

    function wait(milliseconds) {
      return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
    }

    function rememberDismissed() {
      try {
        sessionStorage.setItem(dismissalStorageKey, String(Date.now()));
      } catch (error) {}
    }

    function dismissalCooldownActive() {
      try {
        var dismissedAt = Number(sessionStorage.getItem(dismissalStorageKey) || 0);
        var remaining = dismissedAt ? Math.max(0, dismissalCooldownMs - (Date.now() - dismissedAt)) : 0;
        return Boolean(remaining > 0);
      } catch (error) {
        return false;
      }
    }

    function cartHasValidBundle(cart) {
      var bundles = {};
      (cart.items || []).forEach(function (item) {
        var properties = item.properties || {};
        var token = properties['_B1G2 bundle'];
        if (!token) return;
        if (!bundles[token]) bundles[token] = { offers: 0, gifts: 0 };
        if (properties['_B1G2 offer'] === 'true' && item.quantity >= 1) bundles[token].offers += 1;
        if (properties['_B1G2 gift'] === 'true' && item.quantity === 1) bundles[token].gifts += 1;
      });
      return Object.keys(bundles).some(function (token) {
        return bundles[token].offers === 1 && bundles[token].gifts === required;
      });
    }

    function loadExistingOfferState() {
      // Each qualifying main product starts an independent B1G2 bundle.
      offerAlreadyClaimed = false;
      updateTriggerLabels();
    }

    function setError(message) {
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    }

    function updateTriggerLabels() {
      document.querySelectorAll('[data-ns-b1g2-open]').forEach(function (trigger) {
        var copy = trigger.querySelector('[data-ns-b1g2-trigger-copy]');
        var action = trigger.querySelector('[data-ns-b1g2-trigger-action]');
        if (copy) {
          copy.textContent = offerAlreadyClaimed
            ? 'Votre pack cadeau B1G2 se trouve déjà dans le panier'
            : (selected.size === required ? 'Vos 2 sabres laser gratuits sont prêts' : 'Choisissez 2 sabres laser gratuits');
        }
        if (action) action.textContent = offerAlreadyClaimed ? 'Voir le panier' : (selected.size === required ? 'Modifier' : 'Choisir');
      });
    }

    function updateSelection(message) {
      cards.forEach(function (card) {
        card.setAttribute('aria-pressed', selected.has(card.dataset.variantId) ? 'true' : 'false');
      });

      count.textContent = selected.size + '/' + required;
      var remaining = required - selected.size;
      status.textContent = message || (remaining > 0
        ? 'Choisissez encore ' + remaining + (remaining === 1 ? ' sabre laser' : ' sabres laser')
        : 'Les 2 sabres laser gratuits sont sélectionnés');
      confirmButton.disabled = selected.size !== required || busy;
      if (skipButton) skipButton.disabled = busy;
      confirmButton.textContent = selected.size === required
        ? 'Ajouter les 3 articles au panier'
        : 'Encore ' + remaining + ' à choisir';
      updateTriggerLabels();
    }

    function openModal(form) {
      pendingForm = form || null;
      lastFocused = document.activeElement;
      setError('');
      modal.hidden = false;
      document.body.classList.add('ns-b1g2-modal-open');
      updateSelection();
      window.requestAnimationFrame(function () { dialog.focus(); });
    }

    function closeModal() {
      if (busy) return;
      rememberDismissed();
      modal.hidden = true;
      pendingForm = null;
      document.body.classList.remove('ns-b1g2-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function triggerMarkup() {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ns-b1g2-trigger';
      button.setAttribute('data-ns-b1g2-open', '');
      button.innerHTML = '<span class="ns-b1g2-trigger__mark" aria-hidden="true">x2</span>' +
        '<span class="ns-b1g2-trigger__copy"><strong>1 ACHETÉ, 2 OFFERTS</strong><span data-ns-b1g2-trigger-copy>Choisissez 2 sabres laser gratuits</span></span>' +
        '<span class="ns-b1g2-trigger__action" data-ns-b1g2-trigger-action>Choisir</span>';
      return button;
    }

    function findMainProductForm() {
      var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function (form) {
        return String(form.getAttribute('id') || '').indexOf('product-form-main-') === 0;
      }) ||
        forms.find(function (form) {
          return !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal');
        }) || null;
    }

    function findBuyButtons(form) {
      if (!form) return null;
      return form.querySelector('.product-info__buy-buttons, .product-form__buy-buttons') ||
        form.closest('.product-info__buy-buttons, .product-form__buy-buttons');
    }

    function ensureTrigger() {
      var form = findMainProductForm();
      var buyButtons = findBuyButtons(form);
      if (!buyButtons || form.querySelector('[data-ns-b1g2-open]')) return;
      buyButtons.insertAdjacentElement('beforebegin', triggerMarkup());
      updateTriggerLabels();
    }

    function isMainProductForm(form) {
      return Boolean(form && form === findMainProductForm());
    }

    function getMainItem(form, bundleToken) {
      var formData = new FormData(form);
      var variantId = Number(formData.get('id'));
      var quantity = Math.max(1, Number(formData.get('quantity') || 1));
      var properties = {};

      if (bundleToken) {
        properties['_B1G2 offer'] = 'true';
        properties['_B1G2 bundle'] = bundleToken;
      }

      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });

      if (!variantId) throw new Error('Veuillez d’abord sélectionner une configuration disponible.');

      var item = { id: variantId, quantity: quantity };
      if (Object.keys(properties).length) item.properties = properties;
      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }

    function getGiftItems(bundleToken) {
      return Array.from(selected).map(function (variantId) {
        return {
          id: Number(variantId),
          quantity: 1,
          properties: { '_B1G2 gift': 'true', '_B1G2 bundle': bundleToken }
        };
      });
    }

    function rollbackBundle(cart, bundleToken) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties['_B1G2 bundle'] === bundleToken) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return Promise.resolve();
      return requestJson(routesRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).catch(function () {});
    }

    function verifyBundle(cart, bundleToken) {
      var bundleItems = (cart.items || []).filter(function (item) {
        return item.properties && item.properties['_B1G2 bundle'] === bundleToken;
      });
      var gifts = bundleItems.filter(function (item) {
        return item.properties['_B1G2 gift'] === 'true';
      });
      var paidProduct = bundleItems.some(function (item) {
        return item.properties['_B1G2 offer'] === 'true';
      });
      var freeGifts = gifts.filter(function (item) {
        return item.original_line_price > 0 && item.final_line_price === 0;
      });
      return paidProduct && gifts.length === required && freeGifts.length === required;
    }

    function applyDiscountAndVerify(bundleToken, attemptsRemaining) {
      return requestJson(routesRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: discountCode })
      })
        .then(function () { return wait(350); })
        .then(function () { return requestJson(routesRoot() + 'cart.js'); })
        .then(function (cart) {
          if (verifyBundle(cart, bundleToken)) return cart;
          if (attemptsRemaining > 1) {
            return wait(450).then(function () {
              return applyDiscountAndVerify(bundleToken, attemptsRemaining - 1);
            });
          }
          var error = new Error('La réduction B1G2 n’a pas pu être confirmée. Votre panier n’a pas été modifié. Veuillez réessayer.');
          error.cart = cart;
          throw error;
        });
    }

    function rollbackAfterFailure(bundleToken, knownCart) {
      var cartPromise = knownCart ? Promise.resolve(knownCart) : requestJson(routesRoot() + 'cart.js');
      return cartPromise
        .then(function (cart) { return rollbackBundle(cart, bundleToken); })
        .catch(function () {});
    }

    function addBundle(form) {
      if (busy) return;
      if (selected.size !== required) {
        openModal(form);
        return;
      }

      busy = true;
      setError('');
      updateSelection('Votre pack de sabres laser est en cours d’ajout...');
      var bundleToken = 'b1g2-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var items;

      try {
        items = [getMainItem(form, bundleToken)].concat(getGiftItems(bundleToken));
      } catch (error) {
        busy = false;
        setError(error.message);
        updateSelection();
        return;
      }

      requestJson(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          return applyDiscountAndVerify(bundleToken, 3);
        })
        .then(function () {
          window.location.assign(cartUrl);
        })
        .catch(function (error) {
          rollbackAfterFailure(bundleToken, error.cart).then(function () {
            busy = false;
            setError(error.message || 'Le pack n’a pas pu être ajouté. Veuillez réessayer.');
            updateSelection();
          });
        });
    }

    function addProductOnly(form) {
      if (busy) return;
      if (!form) {
        setError('La configuration du produit est introuvable. Rechargez la page et réessayez.');
        return;
      }

      busy = true;
      setError('');
      updateSelection('Votre sabre laser est ajouté sans article gratuit...');
      var item;

      try {
        item = getMainItem(form, null);
      } catch (error) {
        busy = false;
        setError(error.message);
        updateSelection();
        return;
      }

      requestJson(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function () { window.location.assign(cartUrl); })
        .catch(function (error) {
          busy = false;
          setError(error.message || 'Le produit n’a pas pu être ajouté. Veuillez réessayer.');
          updateSelection();
        });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (busy) return;
        var variantId = card.dataset.variantId;
        setError('');
        if (selected.has(variantId)) {
          selected.delete(variantId);
          updateSelection();
          return;
        }
        if (selected.size >= required) {
          updateSelection('Désélectionnez d’abord un choix avant d’en sélectionner un autre.');
          return;
        }
        selected.add(variantId);
        updateSelection();
      });
    });

    closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });

    confirmButton.addEventListener('click', function () {
      if (selected.size !== required || busy) return;
      var form = pendingForm || findMainProductForm();
      if (form) addBundle(form);
      else setError('La configuration du produit est introuvable. Rechargez la page et réessayez.');
    });

    if (skipButton) {
      skipButton.addEventListener('click', function () {
        rememberDismissed();
        addProductOnly(pendingForm || findMainProductForm());
      });
    }

    function handleMainProductAdd(form) {
      pendingForm = form;
      if (selected.size !== required && dismissalCooldownActive()) addProductOnly(form);
      else if (selected.size !== required) openModal(form);
      else addBundle(form);
    }

    window.addEventListener('click', function (event) {
      if (document.querySelector('[data-ns-b1g2]') !== root) return;
      var trigger = event.target.closest('[data-ns-b1g2-open]');
      if (trigger) {
        event.preventDefault();
        openModal(findMainProductForm());
        return;
      }

      var addButton = event.target.closest('button[data-action="add-to-cart"], input[data-action="add-to-cart"]');
      if (!addButton) return;
      var form = addButton.form || addButton.closest('form[action*="/cart/add"]');
      if (!isMainProductForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      handleMainProductAdd(form);
    }, true);

    document.addEventListener('submit', function (event) {
      if (document.querySelector('[data-ns-b1g2]') !== root) return;
      if (!isMainProductForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      handleMainProductAdd(event.target);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (document.querySelector('[data-ns-b1g2]') !== root) return;
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    ensureTrigger();
    var productRoot = document.querySelector('product-rerender[id^="product-info-"]') ||
      document.querySelector('.product-block-list__item--info') || document.body;
    new MutationObserver(ensureTrigger).observe(productRoot, { childList: true, subtree: true });
    loadExistingOfferState();
    updateSelection();
  }

  function startB1G2() {
    initB1G2();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startB1G2);
  else startB1G2();
})();
